const TEDER_CONFIG = () => {
  return {
    Endpoint: process.env.REACT_APP_API_ENDPOINT || "https://hed69859e7.execute-api.us-east-1.amazonaws.com/test",
    Resources: [
      "shows",
      "login",
      "artist",
      "admin",
      "schedule_event",
      "get_booking_agent_assigned_artists",
      "admin_get_customers",
    ],
    ShowsPhotoUrl: process.env.REACT_APP_SHOWS_PHOTO_URL || "https://teder-test-photos.s3.amazonaws.com/shows-photo/",
    ArtistPhotoUrl: process.env.REACT_APP_ARTIST_PHOTO_URL || "https://teder-test-photos.s3.amazonaws.com/artist-photo/",
    BaseUrl: process.env.REACT_APP_BASE_URL || "https://d10e7vgh9pog33.cloudfront.net",
    StripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "pk_test_placeholder",
    SentryDSN: process.env.REACT_APP_SENTRY_DSN || "",
  };
};

export default TEDER_CONFIG;
